import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchSyncStatus, forceUnlock, runNowJob, setJobEnabled } from "@/api/syncCenter";

const STATUS_KEY = ["syncCenter", "status"] as const;
const STATUS_STALE = 15_000;

export function useSyncStatus(enabled = true) {
  return useQuery({
    queryKey: STATUS_KEY,
    queryFn: ({ signal }) => fetchSyncStatus(signal),
    staleTime: STATUS_STALE,
    // Don't fire for non-viewers (manager) — avoids a spurious 403 console error.
    enabled,
  });
}

export function useSetJobEnabled() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ jobId, override }: { jobId: string; override: "inherit" | "disabled" }) =>
      setJobEnabled(jobId, override),
    onSuccess: () => qc.invalidateQueries({ queryKey: STATUS_KEY }),
  });
}

export function useRunNowJob() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ jobId, mode, reason }: { jobId: string; mode: string; reason: string }) =>
      runNowJob(jobId, mode, reason),
    onSuccess: () => qc.invalidateQueries({ queryKey: STATUS_KEY }),
  });
}

export function useForceUnlock() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ key, reason }: { key: string; reason: string }) => forceUnlock(key, reason),
    onSuccess: () => qc.invalidateQueries({ queryKey: STATUS_KEY }),
  });
}
